export const APP_VERSION = process.env.VUE_APP_VERSION_NAME || "";
export const isSG =
  APP_VERSION.startsWith("SG") ||
  APP_VERSION.startsWith("NOSG") ||
  APP_VERSION.startsWith("POSG");
export const isNOSG = APP_VERSION.startsWith("NOSG");
export const isPOSG = APP_VERSION.startsWith("POSG");
// Wersja testowa — nazwę generuje set-version.js jako `TEST<dd><mm><yy>`.
export const isTEST = APP_VERSION.startsWith("TEST");
// Lokalny dev (`.env.development.local` → VUE_APP_VERSION_NAME=LOCAL_DEV).
export const isLocalDev = APP_VERSION === "LOCAL_DEV";
// Wersje NIEprodukcyjne (test + lokalny dev): sesja ma przeżyć przeładowanie strony (F5),
// żeby użytkownik nie był wylogowywany przy odświeżaniu. Patrz auth.store.js.
// UWAGA: warianty produkcyjne (SG/NOSG/POSG) NIE są tu ujęte — u nich zachowanie bez zmian.
export const isPersistSessionOnReload = isTEST || isLocalDev;
